/**
 * @prettier
 */

import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.less';

const List = ({ children }) => {
  return (
    <div className={styles.checklistContainer}>
      <ul className={styles.checklist}>{children}</ul>
    </div>
  );
};

List.propTypes = {
  children: PropTypes.node,
};

const Item = ({ children }) => {
  return (
    <li className={styles.checklistItem}>
      <div className={styles.checklistBullet} />
      <div>{children}</div>
    </li>
  );
};

Item.propTypes = {
  children: PropTypes.node,
};

const Header = ({ children }) => {
  return <div className={styles.checklistItemHeader}>{children}</div>;
};

Header.propTypes = {
  children: PropTypes.node,
};

const Body = ({ children }) => {
  return <div className={styles.checklistItemBody}>{children}</div>;
};

Body.propTypes = {
  children: PropTypes.node,
};

export default { List, Item, Header, Body };
